<template>
  <div>
    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
        {{ $t("navigationDrawerMenu.createAdmin") }}
      </v-card-title>

      <v-divider />

      <ValidationObserver v-slot="{ handleSubmit }" ref="createAdminObserver">
        <form @submit.prevent="handleSubmit(createAdmin)">
          <v-card-text class="align-center">
            <ValidationProvider
              :name="$t('labels.userUsername')"
              rules="required|numeric"
              v-slot="{ errors }"
              ><v-text-field
                v-model="form.Username"
                :label="$t('labels.userUsername')"
                outlined
                :hint="$t('descriptions.usernameWarning')"
                :error-messages="errors[0]"
              ></v-text-field
            ></ValidationProvider>
            <ValidationProvider
              :name="$t('labels.firstName')"
              rules="required|alpha"
              v-slot="{ errors }"
              ><v-text-field
                v-model="form.Name"
                :label="$t('labels.firstName')"
                outlined
                :error-messages="errors[0]"
              ></v-text-field
            ></ValidationProvider>
            <ValidationProvider
              :name="$t('labels.lastName')"
              rules="required"
              v-slot="{ errors }"
              ><v-text-field
                v-model="form.Surname"
                :label="$t('labels.lastName')"
                outlined
                :error-messages="errors[0]"
              ></v-text-field
            ></ValidationProvider>
            <ValidationProvider
              :name="$t('labels.password')"
              rules="required"
              v-slot="{ errors }"
              ><v-text-field
                v-model="form.Password"
                :label="$t('labels.password')"
                outlined
                :error-messages="errors[0]"
                type="password"
              ></v-text-field
            ></ValidationProvider>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              type="submit"
              large
              color="red"
              dark
              class="mb-4"
              style="text-transform: none; color: white"
            >
              {{ $t("navigationDrawerMenu.createAdmin") }}
            </v-btn>
          </v-card-actions>
        </form>
      </ValidationObserver>
    </v-card>
  </div>
</template>

<script>
import AccountService from "../services/AccountService";

export default {
  data: () => ({
    form: {},
  }),

  watch: {},
  mounted() {},

  computed: {},

  methods: {
    createAdmin() {
      this.$store.state.loadingStatus = true;
      AccountService.createAdmin(this.form)
        .then((response) => {
          window.showSuccess(this.$t("messages.addedAdminSuccessfully"));
          this.reset();
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    reset() {
      this.form = {};
      if (this.$refs.createAdminObserver) {
        this.$refs.createAdminObserver.reset();
      }
    },
  },
};
</script>
